import React, { useCallback, useEffect } from "react";
import "./product-3d-config-tabs.scss";
import "../AddFolder/AddFolder.scss";


import { motion } from "framer-motion";

import { Checkbox, DatePicker, Drawer, Input, Row, Spin, Tabs, Tooltip } from "antd";
import "antd/dist/antd.css";
import { CustomTab } from "./custom-tab/CustomTab";
import { PantsIcon } from "./icons/PantsIcon";
import { FabricIcon } from "./icons/FabricIcon";
import { ColorsIcon } from "./icons/ColorsIcon";
import { LazerIcon } from "./icons/LazerIcon";
import { DamageIcon } from "./icons/DamageIcon";
import { CustomDesignIcon } from "./icons/CustomDesignIcon";
import { StylingForm } from "./forms/StylingForm";
import { FabricForm } from "./forms/FabricForm";
import { ColorsForm } from "./forms/ColorsForm";
import { LazerForm } from "./forms/LazerForm";
import { DamageForm } from "./forms/DamageForm";
import { MyOwnDesignForm } from "./forms/MyOwnDesignForm";
import { OrderButton } from "./forms/buttons/OrderButton";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import {
  createCustomizedProduct,
  getCollaborators,
  orderCustomizedProduct,
} from "../../actions/order-actions/actions";
import order_sent from "../../img/order_sent.jpg";
import { history } from "../../index";
import "./forms/buttons/order-button-h.scss";
import BottomDrawer from "../BottomDrawer/BottomDrawer";
import { handleBottomDrawer } from "../../actions/actionCreators";
import OrderServices from "../../actions/order-actions/services";
import {
  CREATE_CUSTOMIZED_PRODUCT_FAIL,
  CREATE_CUSTOMIZED_PRODUCT_REQUEST,
  CREATE_CUSTOMIZED_PRODUCT_SUCCESS,
} from "../../actions/order-actions/types";
import { MyNotif } from "../NotifIcons/NotifIcons";
import { FolderOpenFilled, LoadingOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import axios from "axios";
import Folder from "../Folder/Folder";
import {
  createFolder,
  getAllFolders,
  clearfolderToMoveTo,
} from "../../actions/folders-actions/actions";

import { removeAlert, setAlert } from "../../actions/alerts-actions/actions";
import { v4 as uuidv4 } from "uuid";
import Bag from "../../icons/Bag";
import { Spinner } from "../Spinner";
import moment from "moment";
import MyCustomSelect from "react-select";
import axiosInstance from "../../config/axios-instance";
import folder_content from "../../img/folder_content_2.png";

import customizeIcon from "../../img/customize_icon.svg";
import { BrushIcon } from "./forms/canvas/icon/BrushIcon";
import { BrushIconWhite } from "../../icons/BrushIconWhite";
import PlusIcon from "../../icons/PlusIcon";
import Select from "react-select";

const { TabPane } = Tabs;

export type IProduct3dConfigTabsProps = {
  selectedProduct: any;
  // originalProduct: any;
};

const Product3dConfigTabs: React.FC<IProduct3dConfigTabsProps> = ({
  selectedProduct,
  // originalProduct,
}) => {
  const params = useParams<any>();
  console.log(params);
  const [activeTabKey, setActiveTabKey] = React.useState("1");
  const [notApproveIsVisible, setNotApproveIsVisible] = React.useState(false);
  const [addToCollection, setAddToCollection] = React.useState(false);
  const [orderNow, setOrderNow] = React.useState(false);
  const [tags, setTags] = React.useState([]);
  const { user, isAdmin } = useSelector((state: RootStateOrAny) => state.auth);

  const [createCollection, setCreateCollection] = React.useState(false);

  const [selectedFolderId, setSelectedFolderId] = React.useState<any>(null);

  const [productsToOrder, setProductsToOrder] = React.useState<any>([]);

  const [disable, setDisable] = React.useState(false);
  const [collection_name, setOrderName] = React.useState("");
  const [orderDetails, setOrderDetails] = React.useState("");
  const [collaborator, setCollaborator] = React.useState([]);
  const [isRequired, setIsRequired] = React.useState(false);
  const [date_delivery, setDeliveryDate] = React.useState("");
  const [startCustom, setStartCustom] = React.useState(false);

  const [saison, setSaison] = React.useState("");

  const { collaborators, newOrder, orders, createOrderLoading, selectedOrder } =
    useSelector((state: any) => state.orders);

  useEffect(() => {
    dispatch(getCollaborators(""));
  }, []);

  const handleCollabChange = (e: any) => {
    let arryColl: any = [];
    e &&
      e.map((el: any) => {
        arryColl.push(el.value);
      });
    setCollaborator(arryColl);
  };

  function handleChangeSeason(e: any) {
    setSaison(e.target.value);
  }

  function handleChangeOrderName(e: any) {
    setOrderName(e.target.value);
  }

  const handleCheckboxChange = (folderId: any) => {
    // Update the selected folder ID
    setSelectedFolderId(folderId);
  };

  const folders = useSelector((state: any) => state.folders);

  const [folderData, setfolderData] = React.useState({
    name: "",
    description: "",
    collaborator: [],
    season: "",
    year: "",
  });

  const handleChangeName = (e: any) => {
    setfolderData({ ...folderData, [e.target.name]: e.target.value });
  };

  const handleCollabChangeFolder = (e: any) => {
    setfolderData({
      ...folderData,
      collaborator: e && e.map((el: any) => el.value),
    });
  };
  const createNewFolder = () => {
    console.log(folderData.name);
    if (folderData.name === "") {
      var id = uuidv4();
      console.log(folderData.name === "");
      MyNotif("Folder name is required.", "danger");
    } else {
      dispatch(createFolder({ ...folderData }));
      // dispatch(getAllFolders());
      setCreateCollection(false);
    }

    setfolderData({
      name: "",
      description: "",
      collaborator: [],
      season: "",
      year: "",
    });
  };

  useEffect(() => {
    dispatch(getAllFolders());
  }, []);

  const discard = () => {
    setfolderData({
      name: "",
      description: "",
      collaborator: [],
      season: "",
      year: "",
    });
  };

  const [width, setWidth] = React.useState(window.innerWidth);
  const [isLoading, setIsLoading] = React.useState(false);
  const [data, setData] = React.useState<any>({
    style: params.status === "edit" ? selectedProduct.style : "",
    style_details:
      params.status === "edit" ? selectedProduct.style_details : "",
    style_files: [],
    fabric: params.status === "edit" ? selectedProduct.fabric : "none",
    fabric_image: "",
    fabric_details:
      params.status === "edit" ? selectedProduct.fabric_details : "",
    fabric_files: [],
    color: params.status === "edit" ? selectedProduct.color : "",
    color_details:
      params.status === "edit" ? selectedProduct.color_details : "",
    color_files: [],
    // laser_images: "",
    laser_images_design: "",
    laser_images_drawing: "",
    laser_type_images: "",
    laser_details:
      params.status === "edit" ? selectedProduct.laser_details : "",
    damage_images: "",
    damage_details:
      params.status === "edit" ? selectedProduct.damage_details : "",
    damage_type_images: "",
    design_details:
      params.status === "edit" ? selectedProduct.design_details : "",
    design_images: "",
    design_type_images: [],
    feedback: params.status === "edit" ? selectedProduct.feedback : "",
    ordered: false,
    pantone_code_knit: "",
    name: selectedProduct && selectedProduct.name,

    tmp_laser_images_drawing_front:
      params.status === "edit"
        ? selectedProduct?.tmp_laser_images_drawing_front
          ? JSON.parse(
              JSON.parse(selectedProduct?.tmp_laser_images_drawing_front)
            )
          : []
        : [],
    tmp_laser_images_drawing_back:
      params.status === "edit"
        ? selectedProduct?.tmp_laser_images_drawing_back
          ? JSON.parse(
              JSON.parse(selectedProduct?.tmp_laser_images_drawing_back)
            )
          : []
        : [],

    tmp_laser_images_design_front:
      params.status === "edit"
        ? selectedProduct?.tmp_laser_images_design_front
          ? JSON.parse(
              JSON.parse(selectedProduct?.tmp_laser_images_design_front)
            )
          : []
        : [],
    tmp_laser_images_design_back:
      params.status === "edit"
        ? selectedProduct?.tmp_laser_images_design_back
          ? JSON.parse(
              JSON.parse(selectedProduct?.tmp_laser_images_design_back)
            )
          : []
        : [],

    tmp_design_front:
      params.status === "edit"
        ? selectedProduct?.tmp_design_front
          ? JSON.parse(JSON.parse(selectedProduct?.tmp_design_front))
          : []
        : [],
    tmp_design_back:
      params.status === "edit"
        ? selectedProduct?.tmp_design_back
          ? JSON.parse(JSON.parse(selectedProduct?.tmp_design_back))
          : []
        : [],

    tmp_damage_front:
      params.status === "edit"
        ? selectedProduct?.tmp_damage_front
          ? JSON.parse(JSON.parse(selectedProduct?.tmp_damage_front))
          : []
        : [],
    tmp_damage_back:
      params.status === "edit"
        ? selectedProduct?.tmp_damage_back
          ? JSON.parse(JSON.parse(selectedProduct?.tmp_damage_back))
          : []
        : [],
  });
  const [newDamageTypeImages, setNewDamageTypeImages] = React.useState<any>([]);

  const deletePositionFiles = (id: string, attribute: string) => {
    setData({
      ...data,
      [attribute]: data[attribute].filter((el: any) => el.id !== id),
    });
  };

  function createFile(section: any) {
    console.log(section.name);
    section?.files?.forEach(async (file: any) => {
      let response = await axios.get(
        process.env.REACT_APP_STORAGE_URL + file.file,
        { responseType: "blob" }
      );

      let metadata = {
        type: file.file.slice(-3) === "pdf" ? "application/pdf" : "image/jpeg",
      };
      const blob = new Blob([response.data]);
      let newFile = new File([blob], file.file, metadata);

      Object.defineProperties(newFile, {
        preview: {
          value: URL.createObjectURL(blob),
          writable: true,
        },
        name: {
          value: file.file,
          writable: true,
        },
        color: {
          value: file?.color,
          writable: true,
        },
      });
      setData((x: any) => {
        console.log({ sectionName: section.name, file: newFile });
        return {
          ...x,
          [section.name]: [...x[section.name], newFile],
        };
      });
    });
  }

  useEffect(() => {
    if (params.status === "edit") {
      let styleFiles = selectedProduct?.style_files
        ? JSON.parse(selectedProduct.style_files)
        : [];
      let fabricFiles = selectedProduct?.fabric_files
        ? JSON.parse(selectedProduct?.fabric_files)
        : [];
      let colorFiles = selectedProduct?.color_files
        ? JSON.parse(selectedProduct?.color_files)
        : [];
      let laserTypeFiles = selectedProduct?.laser_type_images
        ? JSON.parse(selectedProduct?.laser_type_images)
        : [];
      let damageTypeFiles = selectedProduct?.damage_type_images
        ? JSON.parse(selectedProduct?.damage_type_images)
        : [];
      let designTypeFiles = selectedProduct?.design_type_images
        ? JSON.parse(selectedProduct?.design_type_images)
        : [];

      [
        { files: styleFiles, name: "style_files" },
        { files: fabricFiles, name: "fabric_files" },
        { files: colorFiles, name: "color_files" },
        { files: Object.values(laserTypeFiles), name: "laser_type_images" },
        { files: Object.values(damageTypeFiles), name: "damage_type_images" },
        { files: Object.values(designTypeFiles), name: "design_type_images" },
      ].forEach((el: any) => {
        createFile(el);
      });
    }
  }, [params.productId, params.status]);

  const drawers = useSelector((state: any) => state.drawers);

  const dispatch = useDispatch();

  const mouseMoveFrontLazer = useCallback(
    (mousePosition: { x: number; y: number }) => {
      setData({
        ...data,
        tmp_laser_images_drawing_front: [
          ...data.tmp_laser_images_drawing_front,
          mousePosition,
        ],
      });
    },
    [data]
  );

  const mouseMoveBackLazer = useCallback(
    (mousePosition: { x: number; y: number }) => {
      setData({
        ...data,
        tmp_laser_images_drawing_back: [
          ...data.tmp_laser_images_drawing_back,
          mousePosition,
        ],
      });
    },
    [data]
  );

  const mouseClickFrontLazerDesign = useCallback(
    (mousePosition: { id: string; x: number; y: number; color: string }) => {
      setData({
        ...data,
        tmp_laser_images_design_front: [
          ...data.tmp_laser_images_design_front,
          mousePosition,
        ],
      });
    },
    [data]
  );

  const mouseClickBackLazerDesign = useCallback(
    (mousePosition: { id: string; x: number; y: number; color: string }) => {
      setData({
        ...data,
        tmp_laser_images_design_back: [
          ...data.tmp_laser_images_design_back,
          mousePosition,
        ],
      });
    },
    [data]
  );

  const mouseClickFrontDamage = useCallback(
    (mousePosition: { id: string; x: number; y: number; color: string }) => {
      setData({
        ...data,
        tmp_damage_front: [...data.tmp_damage_front, mousePosition],
      });
    },
    [data]
  );

  const mouseClickBackDamage = useCallback(
    (mousePosition: { id: string; x: number; y: number; color: string }) => {
      setData({
        ...data,
        tmp_damage_back: [...data.tmp_damage_back, mousePosition],
      });
    },
    [data]
  );

  const mouseClickFrontDesign = useCallback(
    (mousePosition: { id: string; x: number; y: number; color: string }) => {
      setData({
        ...data,
        tmp_design_front: [...data.tmp_design_front, mousePosition],
      });
    },
    [data]
  );

  const mouseClickBackDesign = useCallback(
    (mousePosition: { id: string; x: number; y: number; color: string }) => {
      setData({
        ...data,
        tmp_design_back: [...data.tmp_design_back, mousePosition],
      });
    },
    [data]
  );

  const handleImageTypes = (image: { file: any; color: string }) => {
    setData((x: any) => ({
      ...x,
      laser_type_images: [...x.laser_type_images, image],
    }));
  };

  const handleImageTypesDamage = (image: { file: any; color: string }) => {
    setData((x: any) => ({
      ...x,
      damage_type_images: [...x.damage_type_images, image],
    }));
  };

  const handleImageTypesDesign = (image: { file: any; color: string }) => {
    setData((prevState: any) => ({
      ...prevState,
      design_type_images: [...prevState.design_type_images, image],
    }));
  };

  React.useEffect(() => {
    const resize: any = window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [width]);

  useEffect(() => {
    setData({
      ...data,
      selectedProduct,
      // style_files: JSON.parse(JSON.parse(selectedProduct.style_files)),
    });
  }, [params]);

  // handle input values
  const handleChange = (e: any) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  // handle type_images
  /* const handleImageTypes = (image: any, field: string) => {
    setData({ ...data, [field]: [...data[field], image] });
  }; */

  // delete type_images
  const deleteImageTypes = (color: string, field: string) => {
    setData({
      ...data,
      [field]: data[field].filter((el: any) => el.color !== color),
    });
  };
  // handle fabric image
  const handleFabricImage = (image: any, name: any) => {
    setData({ ...data, fabric_image: image, fabric: name });
  };

  // attach file
  const attachFile = (name: string, files: any) => {
    setData({ ...data, [name]: files });
  };

  // delete attached file
  const deleteFile = (name: string, file: any) => {
    setData({
      ...data,
      //@ts-ignore
      [name]: data[name].filter((el: any) => el.name !== file.name),
    });
  };

  // handle Color img
  const handleColorImg = (color: any) => {
    setData({ ...data, color: color });
  };

  const handleSceenShorts = (name: string, img: any) => {
    setData({ ...data, [name]: img });
  };
  const handleSceenShortsDamage = (name: string, img: any) => {
    setData({ ...data, [name]: img });
  };
  const handleSceenShortsTypeLazer = async (name: string, img: any) => {
    await setData({ ...data, [name]: img });
  };

  const handleSceenShortsRight = async (name: string, img: any) => {
    await setData({ ...data, [name]: img });
  };
  const handleSceenShortsLeft = async (name: string, img: any) => {
    await setData({ ...data, [name]: img });
  };
  const handleSceenShortsDesign = (name: string, img: any) => {
    setData({ ...data, [name]: img });
  };

  const openDrawerCustom = (val: any) => {
    setStartCustom(val);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (folders.folderIdToMoveTo != null) {
      var canvasDataBack = localStorage.getItem(
        "canvasDataBack" + selectedProduct.code
      );
      var canvasDataFront = localStorage.getItem(
        "canvasDataFront" + selectedProduct.code
      );
      let formData = new FormData();
      formData.append("folder_id", folders.folderIdToMoveTo);

      Object.keys(data)
        .filter((x: any) => !x.includes("files"))
        .map((el: any) => data[el] && formData.append(el, data[el]));

      /*    data.laser_images = [
      ...(data.laser_images ? data.laser_images : []),
      ...(data.laser_type_images ? data.laser_type_images : []),
    ]; */

      data.laser_images_design = [
        ...(data.laser_images_design ? data.laser_images_design : []),
        ...(data.laser_type_images
          ? data.laser_type_images.map((el: any) => el.file)
          : []),
      ];

      data.damage_images = [
        ...(data.damage_images ? data.damage_images : []),
        ...(data.damage_type_images
          ? data.damage_type_images.map((el: any) => el.file)
          : []),
      ];

      data.design_images = [
        ...(data.design_images ? data.design_images : []),
        ...(data.design_type_images
          ? data.design_type_images.map((el: any) => el.file)
          : []),
      ];

      if (data.laser_type_images.length) {
        for (let i = 0; i < data.laser_type_images.length; i++) {
          if (!data.laser_type_images[i].file) {
            continue;
          }
          formData.append(
            `laser_type_images[${i}][file]`,
            data.laser_type_images[i].file
          );
          formData.append(
            `laser_type_images[${i}][color]`,
            data.laser_type_images[i].color
          );
        }
      }

      if (data.damage_type_images.length) {
        for (let i = 0; i < data.damage_type_images.length; i++) {
          if (!data.damage_type_images[i].file) {
            continue;
          }
          formData.append(
            `damage_type_images[${i}][file]`,
            data.damage_type_images[i].file
          );
          formData.append(
            `damage_type_images[${i}][color]`,
            data.damage_type_images[i].color
          );
        }
      }

      if (data.design_type_images.length) {
        for (let i = 0; i < data.design_type_images.length; i++) {
          if (!data.design_type_images[i].file) {
            continue;
          }
          formData.append(
            `design_type_images[${i}][file]`,
            data.design_type_images[i].file
          );
          formData.append(
            `design_type_images[${i}][color]`,
            data.design_type_images[i].color
          );
        }
      }

      if (data.style_files.length) {
        for (let i = 0; i < data.style_files.length; i++) {
          formData.append(`style_files[${i}]`, data.style_files[i]);
        }
      }
      if (data.fabric_files.length) {
        for (let i = 0; i < data.fabric_files.length; i++) {
          formData.append(`fabric_files[${i}]`, data.fabric_files[i]);
        }
      }
      if (data.color_files.length) {
        for (let i = 0; i < data.color_files.length; i++) {
          formData.append(`color_files[${i}]`, data.color_files[i]);
        }
      }

      if (data.damage_images) {
        for (let i = 0; i < data.damage_images.length; i++) {
          formData.append(`damage_images[${i}]`, data.damage_images[i]);
        }
      }
      /*   if (data.laser_images) {
      for (let i = 0; i < data.laser_images.length; i++) {
        formData.append(`laser_images[${i}]`, data.laser_images[i]);
      }
    }
 */

      if (data.laser_images_design) {
        for (let i = 0; i < data.laser_images_design.length; i++) {
          formData.append(
            `laser_images_design[${i}]`,
            data.laser_images_design[i]
          );
        }
      }
      if (data.laser_images_drawing) {
        for (let i = 0; i < data.laser_images_drawing.length; i++) {
          formData.append(
            `laser_images_drawing[${i}]`,
            data.laser_images_drawing[i]
          );
        }
      }
      if (data.design_images) {
        for (let i = 0; i < data.design_images.length; i++) {
          formData.append(`design_images[${i}]`, data.design_images[i]);
        }
      }
      formData.append(
        "product_id",
        params.status === "new"
          ? selectedProduct.id
          : selectedProduct.product_id
      );
      // create a customized product and order it
      // dispatch(createCustomizedProduct(formData, true));
      // dispatch({
      // formData.append("product_id", selectedProduct.id);
      formData.append(
        "tmp_laser_images_drawing_front",
        JSON.stringify(data.tmp_laser_images_drawing_front)
      );
      formData.append(
        "tmp_laser_images_drawing_back",
        JSON.stringify(data.tmp_laser_images_drawing_back)
      );

      formData.append(
        "tmp_damage_front",
        JSON.stringify(data.tmp_damage_front)
      );
      formData.append("tmp_damage_back", JSON.stringify(data.tmp_damage_back));

      formData.append(
        "tmp_design_front",
        JSON.stringify(data.tmp_design_front)
      );
      formData.append("tmp_design_back", JSON.stringify(data.tmp_design_back));

      formData.append(
        "tmp_laser_images_design_front",
        JSON.stringify(data.tmp_laser_images_design_front)
      );
      formData.append(
        "tmp_laser_images_design_back",
        JSON.stringify(data.tmp_laser_images_design_back)
      );
      formData.append("tmp_canvas_front", JSON.stringify(canvasDataFront));
      formData.append("tmp_canvas_back", JSON.stringify(canvasDataBack));
      // create a customized product and order it
      //  dispatch(createCustomizedProduct(formData, true));

      dispatch({
        type: CREATE_CUSTOMIZED_PRODUCT_REQUEST,
      });
      setIsLoading(true);
      try {
        const response = await OrderServices.createCustomizedProduct(
          formData,
          params.status === "edit",
          params.status === "edit" ? selectedProduct.id : null
        );
        dispatch({
          type: CREATE_CUSTOMIZED_PRODUCT_SUCCESS,
          payload: response.data,
        });
        // await dispatch(orderCustomizedProduct(response.data.id));
        setIsLoading(false);
        setNotApproveIsVisible(true);
        setAddToCollection(false);
        dispatch(clearfolderToMoveTo());
        setTimeout(() => {
          setNotApproveIsVisible(false);
        }, 2000);

        /*  var newUrl =
        window.location.origin + "/myCollection?section=mycustomized";
      window.location.href = newUrl; */
      } catch (error: any) {
        // await dispatch({
        //   type: CREATE_CUSTOMIZED_PRODUCT_FAIL,
        //   payload: error.response,
        // });
        setIsLoading(false);
        MyNotif("Make at least one modification", "danger");
      }
    } else {
      MyNotif("Please select the collection", "danger");
    }
  };

  const orderNowProduct = async (e: any) => {
    e.preventDefault();

    console.log(data);

    if (date_delivery != "" && collection_name != "") {
      setDisable(true);

      let token = localStorage.getItem("token");
      console.log(disable);

      var canvasDataBack = localStorage.getItem(
        "canvasDataBack" + selectedProduct.code
      );
      var canvasDataFront = localStorage.getItem(
        "canvasDataFront" + selectedProduct.code
      );
      let formData = new FormData();

      Object.keys(data)
        .filter((x: any) => !x.includes("files"))
        .map((el: any) => data[el] && formData.append(el, data[el]));

      /*    data.laser_images = [
        ...(data.laser_images ? data.laser_images : []),
        ...(data.laser_type_images ? data.laser_type_images : []),
      ]; */

      data.laser_images_design = [
        ...(data.laser_images_design ? data.laser_images_design : []),
        ...(data.laser_type_images
          ? data.laser_type_images.map((el: any) => el.file)
          : []),
      ];

      data.damage_images = [
        ...(data.damage_images ? data.damage_images : []),
        ...(data.damage_type_images
          ? data.damage_type_images.map((el: any) => el.file)
          : []),
      ];

      data.design_images = [
        ...(data.design_images ? data.design_images : []),
        ...(data.design_type_images
          ? data.design_type_images.map((el: any) => el.file)
          : []),
      ];

      if (data.laser_type_images.length) {
        for (let i = 0; i < data.laser_type_images.length; i++) {
          if (!data.laser_type_images[i].file) {
            continue;
          }
          formData.append(
            `laser_type_images[${i}][file]`,
            data.laser_type_images[i].file
          );
          formData.append(
            `laser_type_images[${i}][color]`,
            data.laser_type_images[i].color
          );
        }
      }

      if (data.damage_type_images.length) {
        for (let i = 0; i < data.damage_type_images.length; i++) {
          if (!data.damage_type_images[i].file) {
            continue;
          }
          formData.append(
            `damage_type_images[${i}][file]`,
            data.damage_type_images[i].file
          );
          formData.append(
            `damage_type_images[${i}][color]`,
            data.damage_type_images[i].color
          );
        }
      }

      if (data.design_type_images.length) {
        for (let i = 0; i < data.design_type_images.length; i++) {
          if (!data.design_type_images[i].file) {
            continue;
          }
          formData.append(
            `design_type_images[${i}][file]`,
            data.design_type_images[i].file
          );
          formData.append(
            `design_type_images[${i}][color]`,
            data.design_type_images[i].color
          );
        }
      }

      if (data.style_files.length) {
        for (let i = 0; i < data.style_files.length; i++) {
          formData.append(`style_files[${i}]`, data.style_files[i]);
        }
      }
      if (data.fabric_files.length) {
        for (let i = 0; i < data.fabric_files.length; i++) {
          formData.append(`fabric_files[${i}]`, data.fabric_files[i]);
        }
      }
      if (data.color_files.length) {
        for (let i = 0; i < data.color_files.length; i++) {
          formData.append(`color_files[${i}]`, data.color_files[i]);
        }
      }

      if (data.damage_images) {
        for (let i = 0; i < data.damage_images.length; i++) {
          formData.append(`damage_images[${i}]`, data.damage_images[i]);
        }
      }
      /*   if (data.laser_images) {
        for (let i = 0; i < data.laser_images.length; i++) {
          formData.append(`laser_images[${i}]`, data.laser_images[i]);
        }
      }
   */

      if (data.laser_images_design) {
        for (let i = 0; i < data.laser_images_design.length; i++) {
          formData.append(
            `laser_images_design[${i}]`,
            data.laser_images_design[i]
          );
        }
      }
      if (data.laser_images_drawing) {
        for (let i = 0; i < data.laser_images_drawing.length; i++) {
          formData.append(
            `laser_images_drawing[${i}]`,
            data.laser_images_drawing[i]
          );
        }
      }
      if (data.design_images) {
        for (let i = 0; i < data.design_images.length; i++) {
          formData.append(`design_images[${i}]`, data.design_images[i]);
        }
      }
      formData.append(
        "product_id",
        params.status === "new"
          ? selectedProduct.id
          : selectedProduct.product_id
      );
      // create a customized product and order it
      // dispatch(createCustomizedProduct(formData, true));
      // dispatch({
      // formData.append("product_id", selectedProduct.id);
      formData.append(
        "tmp_laser_images_drawing_front",
        JSON.stringify(data.tmp_laser_images_drawing_front)
      );
      formData.append(
        "tmp_laser_images_drawing_back",
        JSON.stringify(data.tmp_laser_images_drawing_back)
      );

      formData.append(
        "tmp_damage_front",
        JSON.stringify(data.tmp_damage_front)
      );
      formData.append("tmp_damage_back", JSON.stringify(data.tmp_damage_back));

      formData.append(
        "tmp_design_front",
        JSON.stringify(data.tmp_design_front)
      );
      formData.append("tmp_design_back", JSON.stringify(data.tmp_design_back));

      formData.append(
        "tmp_laser_images_design_front",
        JSON.stringify(data.tmp_laser_images_design_front)
      );
      formData.append(
        "tmp_laser_images_design_back",
        JSON.stringify(data.tmp_laser_images_design_back)
      );
      formData.append("tmp_canvas_front", JSON.stringify(canvasDataFront));
      formData.append("tmp_canvas_back", JSON.stringify(canvasDataBack));
      // create a customized product and order it
      //  dispatch(createCustomizedProduct(formData, true));

      dispatch({
        type: CREATE_CUSTOMIZED_PRODUCT_REQUEST,
      });

      const response = await OrderServices.createCustomizedProduct(
        formData,
        params.status === "edit",
        params.status === "edit" ? selectedProduct.id : null
      );

      axiosInstance({
        method: "post",
        url: `/customized_products/order`,
        data: {
          customized_product_ids: [response.data],

          collection_name,
          date_delivery,
          collaborator,
          saison,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(function (response) {
        window.location.href = `/my-orders/customized-orders/in-progress`;
      });

      setDisable(false);
    } else {
      setIsRequired(true);
    }
  };

  const customStylesCreateModern = {
    control: (base: any, state: any) => ({
      ...base,
      background: "white",
      borderColor: state.isFocused ? "#00468c" : "#e2e8f0",
      borderRadius: "8px",
      padding: "2px",
      fontSize: "14px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#00468c",
      },
    }),
    placeholder: (base: any) => ({
      ...base,
      color: "#94a3b8",
    }),
    menu: (base: any) => ({
      ...base,
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e2e8f0",
      zIndex: 100
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? "#00468c" : state.isFocused ? "#f1f5f9" : "white",
      color: state.isSelected ? "white" : "#1e293b",
      padding: "10px 12px",
      fontSize: "14px",
      cursor: "pointer"
    }),
  };

  const currentYear = new Date().getFullYear();

  const options_year = [
    { value: String(currentYear).slice(2), label: String(currentYear) },

    { value: String(currentYear + 1).slice(2), label: String(currentYear + 1) },
    { value: String(currentYear + 2).slice(2), label: String(currentYear + 2) },
    { value: String(currentYear + 3).slice(2), label: String(currentYear + 3) },
    { value: String(currentYear + 4).slice(2), label: String(currentYear + 4) },
  ];

  const options_season = [
    { value: "ps", label: "PS" },
    { value: "ss", label: "SS" },
    { value: "pf", label: "PF" },
    { value: "fw", label: "FW" },
  ];

  const handleSeasonChange = (e: any) => {
    setfolderData({
      ...folderData,
      season: e.value,
    });
  };
  const handleYearChange = (e: any) => {
    setfolderData({
      ...folderData,
      year: e.value,
    });
  };
  return (
    <div className="product-3d-config-tabs">
      <div className="row top-header ml-2 mb-5 justify-content-between">
        {/* <div className="product-name">{selectedProduct.name}</div> */}
        <div className={"col-6"}>
          <h4 className="product-code h4_medium mb-0 mt-2">
            {params.status === "new"
              ? selectedProduct?.code
              : selectedProduct?.original_product?.code}
          </h4>
          <h4 className="product-name" style={{ fontWeight: 400 }}>
            {params.status === "new"
              ? selectedProduct?.name
              : selectedProduct?.original_product?.name}
          </h4>
        </div>

        <div
          className={"col-6 mb-0 "}
          style={{ display: "flex", justifyContent: "end" }}
        >
          <button
            className="order-btn-h-outlined-add-to-collection-icon "
            onClick={(e: any) => {
              e.preventDefault();
              setAddToCollection(true);
            }}
            /*
              style={{width: "100%"}}
*/
          >
            {/*Add to collection*/}
            <FolderOpenFilled style={{ fontSize: "24px" }}></FolderOpenFilled>
          </button>
        </div>
      </div>
      <form>
        <div>
          <Row className="p-2">
            <StylingForm
              {...{ setActiveTabKey }}
              handleChange={handleChange}
              attachFile={attachFile}
              deleteFile={deleteFile}
              globalData={data}
              selectedProduct={selectedProduct}
            />

            <FabricForm
              {...{ setActiveTabKey }}
              handleChange={handleChange}
              handleFabricImage={handleFabricImage}
              attachFile={attachFile}
              deleteFile={deleteFile}
              globalData={data}
            />
          </Row>
          <div className="pl-4 pr-4">
            <LazerForm
              handleSceenShorts={handleSceenShorts}
              handleSceenShortsTypeLazer={handleSceenShortsTypeLazer}
              handleSceenShortsRight={handleSceenShortsRight}
              handleSceenShortsLeft={handleSceenShortsLeft}
              handleChange={handleChange}
              handleImageTypes={handleImageTypes}
              deleteImageTypes={deleteImageTypes}
              globalData={data}
              mouseMoveFrontLazer={mouseMoveFrontLazer}
              mouseMoveBackLazer={mouseMoveBackLazer}
              mouseClickFrontLazerDesign={mouseClickFrontLazerDesign}
              mouseClickBackLazerDesign={mouseClickBackLazerDesign}
              deletePositionFiles={(id: string, attribute: string) =>
                deletePositionFiles(id, attribute)
              }
              startCustom={startCustom}
              openDrawerCustom={openDrawerCustom}
            />
          </div>
        </div>
        {/* <Tabs
            tabPosition={"left"}
            activeKey={activeTabKey}
            onChange={(key) => setActiveTabKey(key)}
          >
            <TabPane
              tab={
                <CustomTab
                  name={width <= 575 ? "" : "Style"}
                  icon={<PantsIcon />}
                />
              }
              key="1"
            >
              <StylingForm
                {...{ setActiveTabKey }}
                handleChange={handleChange}
                attachFile={attachFile}
                deleteFile={deleteFile}
                globalData={data}
                selectedProduct={selectedProduct}
              />
            </TabPane>
            <TabPane
              tab={
                <CustomTab
                  name={width <= 575 ? "" : "FABRIC"}
                  icon={<FabricIcon />}
                />
              }
              key="2"
            >
              <FabricForm
                {...{ setActiveTabKey }}
                handleChange={handleChange}
                handleFabricImage={handleFabricImage}
                attachFile={attachFile}
                deleteFile={deleteFile}
                globalData={data}
              />
            </TabPane>
                   <TabPane
              tab={
                <CustomTab
                  name={
                    params.status === "edit"
                      ? selectedProduct?.original_product?.fabric_type ===
                        "knit"
                        ? "COLOR"
                        : selectedProduct?.original_product?.fabric_type ===
                            "denim" && "BASE COLOR"
                      : selectedProduct?.fabric_type === "knit"
                      ? "COLOR"
                      : "BASE COLOR"
                  }
                  icon={<ColorsIcon />}
                />
              }
              key="3"
            >
              <ColorsForm
                {...{ setActiveTabKey }}
                handleChange={handleChange}
                handleColorImg={handleColorImg}
                attachFile={attachFile}
                deleteFile={deleteFile}
                globalData={data}
                isDenim={
                  params.status === "edit"
                    ? selectedProduct?.original_product?.fabric_type === "denim"
                    : selectedProduct?.fabric_type === "denim"
                }
              />
            </TabPane> 

            <TabPane
              tab={
                <CustomTab
                  name={width <= 575 ? "" : "LASER INTENSITY"}
                  icon={<LazerIcon />}
                />
              }
              key="4"
            >
              <LazerForm
                handleSceenShorts={handleSceenShorts}
                handleSceenShortsTypeLazer={handleSceenShortsTypeLazer}
                handleChange={handleChange}
                handleImageTypes={handleImageTypes}
                deleteImageTypes={deleteImageTypes}
                globalData={data}
                mouseMoveFrontLazer={mouseMoveFrontLazer}
                mouseMoveBackLazer={mouseMoveBackLazer}
                mouseClickFrontLazerDesign={mouseClickFrontLazerDesign}
                mouseClickBackLazerDesign={mouseClickBackLazerDesign}
                deletePositionFiles={(id: string, attribute: string) =>
                  deletePositionFiles(id, attribute)
                }
              />
            </TabPane>
               <TabPane
              tab={
                <CustomTab
                  name={
                    params.status === "edit"
                      ? selectedProduct?.original_product?.fabric_type ===
                        "knit"
                        ? "Graphic "
                        : selectedProduct?.original_product?.fabric_type ===
                            "denim" && "DAMAGES"
                      : selectedProduct?.fabric_type === "knit"
                      ? "Graphic"
                      : "DAMAGES"
                  }
                  icon={<DamageIcon />}
                />
              }
              key="5"
            >
              <DamageForm
                handleSceenShortsDamage={handleSceenShortsDamage}
                handleChange={handleChange}
                handleImageTypes={handleImageTypesDamage}
                deleteImageTypes={deleteImageTypes}
                globalData={data}
                mouseClickFrontDamage={mouseClickFrontDamage}
                mouseClickBackDamage={mouseClickBackDamage}
                initialDesign={{
                  images: data.damage_type_images || [],
                  front: data.tmp_damage_front || [],
                  back: data.tmp_damage_back || [],
                }}
                deletePositionFiles={(id: string, attribute: string) =>
                  deletePositionFiles(id, attribute)
                }
              />
            </TabPane> 
          {selectedProduct?.fabric_type !== "knit" && (
              <TabPane
                tab={
                  <CustomTab
                    name={width <= 575 ? "" : `ADD YOUR \r\n OWN DESIGN`}
                    icon={<CustomDesignIcon />}
                  />
                }
                key="6"
              >
                <MyOwnDesignForm
                  handleSceenShortsDesign={handleSceenShortsDesign}
                  handleChange={handleChange}
                  handleImageTypes={handleImageTypesDesign}
                  deleteImageTypes={deleteImageTypes}
                  globalData={data}
                  mouseClickFrontDesign={mouseClickFrontDesign}
                  mouseClickBackDesign={mouseClickBackDesign}
                  initialDesign={{
                    images: data?.design_type_images || [],
                    front: data?.tmp_design_front || [],
                    back: data?.tmp_design_back || [],
                  }}
                  deletePositionFiles={(id: string, attribute: string) =>
                    deletePositionFiles(id, attribute)
                  }
                />
              </TabPane>
            )}
          </Tabs> */}

        <div className="btn-configurator-holder-custom-product ">
          {!user.is_client_clients ? (
            <>
              <div className={"col-6 justify-content-end"}>
                <button
                  className=" order-btn-h-outlined-custom"
                  style={{ fontSize: "1rem", width: "100%" }}
                  onClick={(e: any) => {
                    e.preventDefault();
                    setOrderNow(true);
                  }}
                >
                  Order product
                </button>
              </div>
              <div className={"col-6 "}>
                <button
                  type="button"
                  className="order-btn-h-custom-prodcut "
                  onClick={() => {
                    if (width >= 992) setStartCustom(true);
                    else
                      MyNotif(
                        "This feature is only available on desktop site",
                        "danger"
                      );
                  }}
                  style={{ fontSize: "1rem", width: "100%" }}
                >
                  <span className={"button-text "}>
                    <img src={customizeIcon} alt="" /> Customize your product!
                  </span>
                  <span className="button-icon">
                    <img src={customizeIcon} alt="" />
                  </span>
                </button>
              </div>
            </>
          ) : (
            <>
              <div className={"col-12 "}>
                <button
                  type="button"
                  className="order-btn-h-custom-prodcut "
                  onClick={() => {
                    if (width >= 992) setStartCustom(true);
                    else
                      MyNotif(
                        "This feature is only available on desktop site",
                        "danger"
                      );
                  }}
                  style={{ fontSize: "1rem", width: "100%" }}
                >
                  <span className={"button-text "}>
                    <img src={customizeIcon} alt="" /> Customize your product!
                  </span>
                  <span className="button-icon">
                    <img src={customizeIcon} alt="" />
                  </span>
                </button>
              </div>
            </>
          )}
          {/*   <button
            className="order-btn-h"
            style={{ fontSize: "1rem" }}
         
            onClick={handleSubmit}
            
          >
            {isLoading ? (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{ fontSize: 24, color: "white" }}
                    spin
                  />
                }
              />
            ) : (
              "Order product"
            )}
          </button>  */}
          {/* <button
            onClick={handleSubmit}
            className="order-btn-h"
            style={{ fontSize: "1rem" }}
          >
            {isLoading ? (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{ fontSize: 24, color: "white" }}
                    spin
                  />
                }
              />
            ) : (
              "Order Now"
            )}
          </button> */}
        </div>
      </form>
      <Drawer
        className="order_sent_drawer"
        placement={"bottom"}
        closable={true}
        onClose={() => setNotApproveIsVisible(false)}
        visible={notApproveIsVisible}
        key={"bottom"}
      >
        <div className="my-2">
          <h1>Saved!</h1>
          <p>Your customized product have been saved in your collection</p>
        </div>
        <img src={order_sent} alt="order sent" className="img-fluid my-2" />
      </Drawer>

      <Drawer
        className="order_sent_drawer_customized"
        placement={"bottom"}
        closable={false}
        visible={addToCollection}
        key={"bottom"}
      >
          <div style={{ padding: "10px 40px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                <span style={{ fontSize: "16px", fontWeight: 600, color: "#1e293b" }}>Choose a collection</span>
                <Tooltip title="Create New Collection">
                    <button
                        type="button"
                        onClick={() => setCreateCollection(true)}
                        style={{ 
                            width: "36px", 
                            height: "36px", 
                            borderRadius: "50%", 
                            border: "1px solid #e1e8f0", 
                            background: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            color: "#00468c",
                            transition: "all 0.2s"
                        }}
                        onMouseOver={(e) => e.currentTarget.style.background = "#f1f5f9"}
                        onMouseOut={(e) => e.currentTarget.style.background = "white"}
                    >
                        <PlusIcon />
                    </button>
                </Tooltip>
            </div>

            <div className="list_folders" style={{ display: "grid", gridTemplateColumns:"repeat(3, 1fr)", gap: "16px", maxHeight: "400px", overflowY: "auto", padding: "10px" }}>
                {folders.folders &&
                    folders.folders
                        .filter((el: any) => el.client_id == user.id)
                        .map((folder: any) => (
                            <Folder
                                clickable={true}
                                selectOneFolder={true}
                                addToCollection={true}
                                folder={folder}
                                key={folder.id}
                            />
                        ))}
            </div>

            <div className="buttons_grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginTop: "30px" }}>
                <button 
                    type="button"
                    onClick={() => {
                        setAddToCollection(false);
                        dispatch(clearfolderToMoveTo());
                    }}
                    style={{
                        padding: "12px",
                        borderRadius: "10px",
                        border: "1px solid #e1e8f0",
                        background: "white",
                        fontSize: "14px",
                        fontWeight: 600,
                        cursor: "pointer"
                    }}
                >
                    Discard
                </button>
                <button 
                    type="button"
                    onClick={handleSubmit}
                    style={{
                        padding: "12px",
                        borderRadius: "10px",
                        border: "none",
                        background: "#00468c",
                        color: "white",
                        fontSize: "14px",
                        fontWeight: 600,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    disabled={isLoading}
                >
                    {isLoading ? (
                    <Spin
                        indicator={
                        <LoadingOutlined
                            style={{ fontSize: 24, color: "white" }}
                            spin
                        />
                        }
                    />
                    ) : (
                    "Confirm"
                    )}
                </button>
            </div>
          </div>
      </Drawer>

      <Drawer
        className="order_sent_drawer_customized"
        placement={"bottom"}
        closable={false}
        onClose={() => setCreateCollection(false)}
        visible={createCollection}
        key={"bottom"}
      >
        <motion.div
          className={"add_folder_container"}
          style={{
            height: "calc(100vh - 109px)",
            justifyContent: "space-between",
          }}
          transition={{ type: "tween" }}
          initial="enter"
          animate="center"
          exit="exit"
        >
          <div className="create_collection_form_modern" style={{ 
            padding: "24px", 
            borderRadius: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            maxWidth: "800px",
            margin: "0 auto",
            width: "100%"
          }}>
            <h3 style={{ fontSize: "18px", fontWeight: 700, color: "#1e293b", margin: 0 }}>New Collection</h3>
            
            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Name</label>
              <input
                type="text"
                name="name"
                placeholder="e.g. Summer 2027"
                value={folderData.name}
                onChange={handleChangeName}
                style={{ 
                  border: "1px solid #e2e8f0", 
                  borderRadius: "8px", 
                  width: "100%", 
                  outline: "none", 
                  fontSize: "14px", 
                  padding: "10px 14px",
                  background: "white",
                  transition: "border-color 0.2s"
                }}
              />
            </div>

            <div style={{ display: "flex", gap: "16px" }}>
              <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Season</label>
                <Select
                  placeholder="Select Season"
                  options={options_season}
                  value={options_season.find((o: any) => o.value === folderData.season)}
                  onChange={handleSeasonChange}
                  styles={customStylesCreateModern}
                />
              </div>
              <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Year</label>
                <Select
                  placeholder="Select Year"
                  options={options_year}
                  value={options_year.find((o: any) => o.value === folderData.year)}
                  onChange={handleYearChange}
                  styles={customStylesCreateModern}
                />
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Collaborators</label>
              <Select
                isMulti
                placeholder="Search names..."
                options={collaborators?.map((c: any) => ({ label: c.name, value: c.id }))}
                onChange={handleCollabChangeFolder}
                styles={customStylesCreateModern}
              />
            </div>
          </div>

          <div style={{ 
            display: "grid", 
            gridTemplateColumns: "1fr 1fr", 
            gap: "12px", 
            marginTop: "8px", 
            maxWidth: "800px", 
            margin: "0 auto", 
            width: "100%", 
            paddingBottom: "24px" 
          }}>
            <button 
              type="button"
              onClick={() => { discard(); setCreateCollection(false); }} 
              style={{
                padding: "12px",
                borderRadius: "10px",
                border: "1px solid #e1e8f0",
                background: "white",
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer"
              }}
            >
              Discard
            </button>
            <button 
              type="button"
              onClick={() => { createNewFolder(); }} 
              style={{
                padding: "12px",
                borderRadius: "10px",
                border: "none",
                background: "#00468c",
                color: "white",
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer"
              }}
            >
              Create new collection
            </button>
          </div>
        </motion.div>
      </Drawer>

      <Drawer
        className="order_sent_drawer_customized"
        placement={"bottom"}
        closable={true}
        onClose={() => setOrderNow(false)}
        visible={orderNow}
        key={"bottom"}
      >
        <div className="row">
          {/* left container */}

          <div
            className="col-12"
            style={{
              paddingTop: "88px",
              paddingLeft: "112px",
              paddingRight: "112px",
            }}
          >
            <div className="titledrawerConfirm">Order details</div>
            <div style={{ fontSize: "16px", marginBottom: "32px" }}>
              Complete your order by providing the details below.
            </div>
            <div className="row">
              <div className="col-6">
                <div>
                  <label className="mr-3 mb-1">Collection names</label>
                  <Input
                    type="text"
                    style={{
                      borderRadius: "5px",
                      marginBottom: "16px",
                    }}
                    onChange={handleChangeOrderName}
                  ></Input>
                  {isRequired && collection_name === "" && (
                    <span style={{ color: "red" }}>This field is required</span>
                  )}
                </div>
                <div>
                  <label className="mr-3 mb-1">Season</label>
                  <Input
                    type="text"
                    style={{
                      borderRadius: "5px",
                      marginBottom: "16px",
                    }}
                    defaultValue={saison}
                    onChange={handleChangeSeason}
                  ></Input>
                </div>
              </div>

              <div className="col-6">
                {" "}
                <div>
                  <label className="mr-3 mb-0">Select Collaborators</label>
                  <MyCustomSelect
                    isMulti
                    name="colors"
                    placeholder="Select your collaborators"
                    options={
                      collaborators &&
                      collaborators.map((el: any) => {
                        return {
                          label: el.name,
                          value: el.id,
                        };
                      })
                    }
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={handleCollabChange}
                  />
                </div>
                <div>
                  <label className="mr-3 mb-0 mt-3">Delivery date</label>
                  <DatePicker
                    disabledDate={(current) =>
                      current.isBefore(moment().add(15, "days"))
                    }
                    format={"DD/MM/YYYY"}
                    onChange={(date: any, dateString: any) =>
                      setDeliveryDate(dateString)
                    }
                    style={{
                      borderRadius: "5px",
                      width: "100%",
                      marginBottom: "16px",
                    }}
                  />

                  {isRequired && date_delivery === "" && (
                    <span style={{ color: "red" }}>This field is required</span>
                  )}
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <div className="d-flex " style={{ gap: "50px" }}>
                <button
                  //   innerButton="Cancel"
                  onClick={(e: any) => setOrderNow(false)}
                  style={{ marginTop: "16px" }}
                  className="submit_button_white submit_button_white_cancel"
                >
                  Discard
                </button>

                <button
                  className="submit_button_add_to_collection"
                  onClick={(e: any) => orderNowProduct(e)}
                  disabled={disable}
                  style={{ marginTop: "16px" }}
                >
                  {disable ? (
                    <Spin
                      indicator={
                        <LoadingOutlined
                          style={{ fontSize: 24, color: "white" }}
                          spin
                        />
                      }
                    />
                  ) : (
                    <>Confirm order</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
      {/* {drawers.openBottom && (
        <BottomDrawer
          mode={"add_to_collection"}
          addCustomizedProduct
          customizedOrder={{
            ...data,
            product_id:
              params.status === "new"
                ? selectedProduct.id
                : selectedProduct.product_id,
          }}
        />
      )} */}
    </div>
  );
};

export { Product3dConfigTabs };
